import React, { useState, useRef, useEffect, useContext } from "react";
import { FaShoppingCart, FaHeart, FaStar, FaRupeeSign } from "react-icons/fa";
import { useParams } from "react-router";
import { BASE_URL_API } from "../../References/url";
import AuthContext from "../../Store/auth-context";
import styles from "./EachProductDescription.module.css";

const EachProductDescription = () => {
    const authCtx = useContext(AuthContext)
    const { productIdentifier } = useParams()
    const [showSimilarProducts, setShowSimilarProducts] = useState(true);
    const rightColumnRef = useRef(null)

    const [product, setProduct] = useState({
        title: "Flipkart Perfect Homes Carol Engineered Wood Queen Bed",
        price: 11999,
        discountPrice: 7999,
        discount: 33,
        ratings: 4.3,
        reviews: 584,
        highlights: [
            "Engineered Wood Queen Bed",
            "Ideal for modern bedrooms",
            "1 Year Manufacturer Warranty",
        ],
        images: [
            "https://rukminim1.flixcart.com/image/416/416/bed/q/k/s/engineered-wood-queen-perfect-homes-original-imafzu52py2b4ev9.jpeg",
            "https://rukminim1.flixcart.com/image/416/416/bed/q/k/s/engineered-wood-queen-perfect-homes-original-imafzu52qspvbxzd.jpeg",
        ],
        offers: [
            "10% off on Axis Bank Credit Card",
            "5% Cashback on Flipkart Axis Bank Card",
        ],
    })

    // Scroll event to detect the end of the right column
    const handleScroll = () => {
        const element = rightColumnRef.current;
        if (element) {
            const isScrolledToBottom =
                element.scrollTop + element.clientHeight >= element.scrollHeight;
            setShowSimilarProducts(isScrolledToBottom);
        }
    };

    const getIndiProductData = async () => {
        const getIndiProductDataResponse = await fetch(BASE_URL_API + "/getIndiProductData",
            {
                method: "POST",
                body: JSON.stringify({
                    token : authCtx.token,
                    productIdentifier: productIdentifier
                })
            });

        if (!getIndiProductDataResponse.ok) {
            console.log('Something went wrong : Server Error')
        } else {
            const getIndiProductDataRespo = await getIndiProductDataResponse.json()
            if (getIndiProductDataRespo.status === "success") {
                setProduct(getIndiProductDataRespo?.response)
            } else {

            }
            console.log(getIndiProductDataRespo)
        }
    }

    useEffect(() => {
        getIndiProductData()
    }, [productIdentifier])

    function normalizeImages(images) {
        // If it's already an array, return it
        if (Array.isArray(images)) return images;

        // If it's a string, try to parse it as JSON
        try {
            const parsed = JSON.parse(images);
            return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
            console.error("Failed to parse images:", error);
            return [];
        }
    }


    return (
        <div>
            <div className={styles.container}>
                {/* Left Column */}
                <div className={styles.leftColumn}>
                    {normalizeImages(product.image_urls).map((image, index) => (
                        <img
                            key={index}
                            src={image}
                            alt={`Product ${index + 1}`}
                            className={styles.productImage}
                        />
                    ))}
                </div>

                {/* Right Column */}
                <div
                    className={styles.rightColumn}
                    ref={rightColumnRef}
                    onScroll={handleScroll}
                >
                    <div className={styles.productTitle}>{product.productTitle}</div>
                    <div className={styles.ratings}>
                        <span className={styles.ratingValue}>
                            {product.ratings} <FaStar />
                        </span>
                        <span className={styles.reviews}>
                            ({product.reviews} Ratings & Reviews)
                        </span>
                    </div>
                    {/* <div className={styles.priceSection}>
                        <span className={styles.discountPrice}>
                            ₹{product.pointsRequired}
                        </span>
                        <span className={styles.originalPrice}>₹{product?.pointsRequired}</span>
                        <span className={styles.discount}>({product?.discount}% off)</span>
                    </div> */}
                    <div
                        dangerouslySetInnerHTML={{ __html: product?.productDescription }}
                    >
                    </div>
                    <div className={styles.offers}>
                        <h3>Available Offers</h3>
                        <ul>
                            {product?.offers?.map((offer, index) => (
                                <li key={index}>{offer}</li>
                            ))}
                        </ul>
                    </div>
                    <div className={styles.actionButtons}>
                        <button className={styles.addToCart}>
                            {/* <FaShoppingCart /> Add to Cart */}
                            <FaRupeeSign /> {product?.offeredPrice}
                        </button>
                        {/* <button className={styles.addToWishlist}>
                            <FaHeart /> Wishlist
                        </button> */}
                    </div>
                    {/* <div className={styles.highlights}>
                        <h3>Highlights</h3>
                        <ul>
                            {product?.highlights?.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div> */}
                    {/* <Specifications />
                    <ProductQuestionAnswers />
                    <ProductReviewsRatings /> */}
                </div>
            </div>

            {/* Similar Products Section */}
            {/* {showSimilarProducts && (
                <div className={styles.similarProducts}>
                    <h2>Similar Products</h2>
                    <div className={styles.similarProductsGrid}>
                        {Array.from({ length: 26 }, (_, i) => (
                            <div key={i} className={styles.similarProductCard}>
                                <p>Product {i + 1}</p>
                            </div>
                        ))}
                    </div>
                </div>
            )} */}
        </div>
    );
};

export default EachProductDescription;
